import styled from "styled-components";

export const HeaderComponent = styled.header.withConfig({
  shouldForwardProp: (prop) => prop !== "isScrolled"
})<{ isScrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  transition: all 0.3s ease;
  padding: ${({ isScrolled }) => (isScrolled ? "0.75rem" : "1.25rem")};

  background: ${({ isScrolled }) =>
    isScrolled ? "rgba(255, 255, 255, 0.7)" : "transparent"};
  backdrop-filter: ${({ isScrolled }) => (isScrolled ? "blur(6px)" : "none")};
  -webkit-backdrop-filter: ${({ isScrolled }) =>
    isScrolled ? "blur(6px)" : "none"};
  box-shadow: ${({ isScrolled }) =>
    isScrolled ? "0px 4px 6px rgba(0, 0, 0, 0.1)" : "none"};
  border-bottom: ${({ isScrolled }) =>
    isScrolled ? "1px solid rgba(200, 200, 200, 0.3)" : "none"};

  @media (max-width: 520px) {
    background: #fff;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const Logo = styled.a`
  display: flex;
  align-items: center;
`;

export const NavigatorItems = styled.nav`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
`;

export const NavigatorItemsLink = styled.a`
  position: relative;
  color: ${({ theme }) => theme.colors.primaryText[8]};
  font-weight: 500;
  font-size: 0.875rem;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary[3]};
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.primary[3]};
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`;

export const AuthContainer = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }
`;

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  transition: background 0.3s ease;

  &.primary {
    background-color: ${({ theme }) => theme.colors.primary[3]};
    border: none;
    color: ${({ theme }) => theme.colors.primaryText.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary[4]};
    }
  }
`;

export const LinkLogin = styled.span`
  color: ${({ theme }) => theme.colors.primaryText[8]};
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: none;
  outline: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary[3]};
    text-decoration: none;
  }
`;

export const MobileMenuButton = styled.button`
  display: block;
  color: ${({ theme }) => theme.colors.primaryText[8]};
  background: none;
  border: none;
  cursor: pointer;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileMenuContainer = styled.div`
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-top: 1px solid rgba(200, 200, 200, 0.3);
  animation: fade-in 0.3s ease-in-out;

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const MobileMenuContent = styled.div`
  width: 100%;
  max-width: 1536px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MobileNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MobileNavLink = styled.span`
  color: ${({ theme }) => theme.colors.primaryText[8]};
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: none;
  outline: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary[3]};
    text-decoration: none;
  }
`;

export const MobileAuthSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.5rem;
`;
